import http from '@/axios/http'
//在线率
export function listOnline(data) {
    if (data.gid == '') {
        delete data.gid
    }
    return http({
        url: '/api/onlineManager/listOnline',
        method: 'post',
        data
    })
}